import { Box } from "@mui/material";
import React from "react";
import Form from "./Form";
import MultiLineChart from "./MultiLineChart";
import { useSelector } from "react-redux";
import CustomerSelectionForm from "./CustomerSelectionForm";
import Table from "./Table";
import ModificationDataTable from "./ModificationDataTable";

export default function Modifications() {
  const state = useSelector((store) => store.analyze);
  const {
    modificationsData,
    modificationsSeries,
    modificationsTD,
    clearAnalyzeModifications,
  } = state;

  return (
    <Box>
      <Form />
      {/* {modificationsData !== null ? <CustomerSelectionForm /> : null} */}
      {modificationsData !== null && clearAnalyzeModifications ? (
        <MultiLineChart />
      ) : null}
      {modificationsTD !== null && clearAnalyzeModifications ? (
        <ModificationDataTable />
      ) : null}
    </Box>
  );
}
